import React from 'react';
import { GoalStatus } from './GoalStatusBadge';

interface GoalMetadataProps {
  status: GoalStatus;
  delayReason?: string;
  postponeReason?: string;
  cancelReason?: string;
  conclusion?: string;
  results?: string;
  outcomeNotes?: string;
  className?: string;
}

const GoalMetadata: React.FC<GoalMetadataProps> = ({
  status,
  delayReason,
  postponeReason,
  cancelReason,
  conclusion,
  results,
  outcomeNotes,
  className = '',
}) => {
  const hasMetadata = delayReason || postponeReason || cancelReason || conclusion || results || outcomeNotes;

  if (!hasMetadata) return null;

  return (
    <div className={`text-sm text-gray-600 space-y-1 ${className}`}>
      {status === 'delayed' && delayReason && (
        <div className="text-red-600">
          <strong>Delay Reason:</strong> {delayReason}
        </div>
      )}
      {status === 'postponed' && postponeReason && (
        <div className="text-yellow-600">
          <strong>Postpone Reason:</strong> {postponeReason}
        </div>
      )}
      {status === 'canceled' && cancelReason && (
        <div className="text-gray-600">
          <strong>Cancel Reason:</strong> {cancelReason}
        </div>
      )}
      {conclusion && (
        <div>
          <strong>Conclusion:</strong> {conclusion}
        </div>
      )}
      {results && (
        <div>
          <strong>Results:</strong> {results}
        </div>
      )}
      {outcomeNotes && (
        <div>
          <strong>Outcome Notes:</strong> {outcomeNotes}
        </div>
      )}
    </div>
  );
};

export default GoalMetadata;

